import { SERVICES, ALL_SERVICE_PAGES } from "@/content/services";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const RESOURCE_SLOTS = ALL_SERVICE_PAGES.flatMap((path) => {
  const service = SERVICES[path];
  const serviceLabel = service.breadcrumb[service.breadcrumb.length - 1];
  const serviceSlug = path.split("/").pop();
  return service.resources.map((r) => ({
    ...r,
    servicePath: path,
    serviceLabel,
    slotKey: `${serviceSlug}--${slug(r.title).slice(0, 64)}`,
  }));
});

export const SLOT_BY_TITLE = new Map(RESOURCE_SLOTS.map((s) => [s.title, s]));

export const SLOTS_BY_SERVICE = ALL_SERVICE_PAGES.map((path) => ({
  path,
  label: SERVICES[path].breadcrumb[SERVICES[path].breadcrumb.length - 1],
  slots: RESOURCE_SLOTS.filter((s) => s.servicePath === path),
}));

export const formatBytes = (n) => {
  if (!n) return "—";
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};
